import React, { FC, ButtonHTMLAttributes } from "react";
import { MoveRight } from "lucide-react";

interface ButtonExploreProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    loading?: boolean;
}

const ButtonExplore: FC<ButtonExploreProps> = ({
    className = "",
    children = "Explore",
    loading = false,
    ...props
}) => {
    return (
        <button
            className={`flex items-center gap-2 py-1.5 px-2 bg-white text-indigo-600 rounded-lg font-black text-[10px] uppercase tracking-widest hover:shadow-lg hover:translate-y-[-1px] transition-all group/btn shrink-0 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
            disabled={loading || props.disabled}
            {...props}
        >
            {loading ? (
                <span className="flex items-center gap-2">
                    <svg className="animate-spin h-3 w-3 text-indigo-600" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    Processing...
                </span>
            ) : (
                <>
                    <span>{children}</span>
                    <MoveRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" strokeWidth={3} />
                </>
            )}
        </button>
    );
};

export default ButtonExplore;
